/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Private_Only_Creator_Can_OpenInputs */



/**
* | output |
* | --- |
* | "Private — only its creator can open it" |
*
* @param {Artifact_Private_Only_Creator_Can_OpenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_private_only_creator_can_open = /** @type {((inputs?: Artifact_Private_Only_Creator_Can_OpenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Private_Only_Creator_Can_OpenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Privat – nur die erstellende Person kann es öffnen")
	return /** @type {LocalizedString} */ ("Private — only its creator can open it")
});